import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { SET_ACCESS_TOKEN, SET_PROFILE_AUTH } from '../../../redux/action/auth/type'
import { useCookies } from "react-cookie";

const AuthOtp = () => {

    const dispatch = useDispatch()

    const navigate = useNavigate();

    const [code, setCode] = useState("");
    const [phone, setPhone] = useState("");

    const [cookies, setCookies, removeCookie] = useCookies()

    // یک توست فعال در یک زمان
    const showToast = (type, msg) => {
        if (toast.isActive("global-toast")) return;
        type(msg, { toastId: "global-toast" });
    };

    // فقط اعداد + محدودیت 4 رقم
    const handleChange = (value) => {
        const persianNumbers = "۰۱۲۳۴۵۶۷۸۹";
        value = value.replace(/[۰-۹]/g, d => persianNumbers.indexOf(d));

        if (!/^[0-9]*$/.test(value)) return;

        if (value.length <= 4) {
            setCode(value);
        }
    };

    // بررسی وضعیت OTP و دسترسی به صفحه
    useEffect(() => {
        const otpData = localStorage.getItem("otp");

        if (!otpData) {
            navigate("/auth");
            return;
        }

        const obj = JSON.parse(otpData);

        if (!obj.otpSended) {
            navigate("/auth");
            return;
        }

        const sendTime = new Date(obj.otpSendTime);
        const now = new Date();

        const diffMinutes = (now - sendTime) / 1000 / 60;

        if (diffMinutes > 2) {
            navigate("/auth");
            return;
        }

        setPhone(obj.phone);

    }, [navigate]);

    // درخواست تایید کد
    const handleVerify = async () => {

    if (code.length !== 4 || !/^[0-9]{4}$/.test(code)) {
        showToast(toast.error, "کد اعتبارسنجی باید ۴ رقم باشد");
        return;
    }

    const otpData = localStorage.getItem("otp");

        if (!otpData) {
            showToast(toast.error, "دسترسی نامعتبر است");
            navigate("/auth");
            return;
        }

        const obj = JSON.parse(otpData);

        // ✅ بررسی انقضای ۲ دقیقه‌ای
        const sendTime = new Date(obj.otpSendTime);
        const now = new Date();
        const diffMinutes = (now - sendTime) / 1000 / 60;

        if (diffMinutes > 2) {
            showToast(
                toast.error,
                "کد ورود شما منقضی شده است - دوباره کد را ارسال کردیم براتون"
            );

            await handleResend();
            return;
        }

        try {
            let res;

            // ✅ اگر لاگین باشد
            if (obj.login === true) {

                res = await axios.post(
                    "https://my-sarad-back.liara.run/api/auth/verify-login-otp",
                    { phone: obj.phone, code }
                );

            } else {
                // ✅ اگر ثبت‌نام باشد

                res = await axios.post(
                    "https://my-sarad-back.liara.run/api/auth/verify-otp",
                    {
                        firstName: obj.firstName,
                        lastName: obj.lastName,
                        phone: obj.phone,
                        code
                    }
                );
            }
            
            dispatch({
                type: SET_ACCESS_TOKEN,
                payload: res?.data?.accessToken
            })

            dispatch({
                type: SET_PROFILE_AUTH,
                payload: res?.data?.user
            })

            // ✅ اگر موفق بود
            showToast(
                toast.success,
                res.data?.message || "عملیات با موفقیت انجام شد"
            );

            setCookies('refreshToken', res?.data?.user?.refreshToken)

            localStorage.removeItem("otp");

            setTimeout(() => navigate("/"), 600);

        } catch (err) {
            const msg = err?.response?.data?.message || "خطایی رخ داده است";
            showToast(toast.error, msg);
        }
    };


    // ارسال مجدد
    const handleResend = async () => {

        const otpData = localStorage.getItem("otp");

        if (!otpData) {
            showToast(toast.error, "دسترسی نامعتبر. ابتدا شماره موبایل را وارد کنید");
            navigate("/auth");
            return;
        }

        const obj = JSON.parse(otpData);

        const sendTime = new Date(obj.otpSendTime);
        const now = new Date();

        const diffMinutes = (now - sendTime) / 1000 / 60;

        // یک دقیقه نگذشته
        if (diffMinutes < 1) {
            showToast(toast.error, "باید ۱ دقیقه بگذرد سپس می‌توانید دوباره ارسال کنید");
            return;
        }

        try {
            let res;

            // login = true → API login
            if (obj.login === true) {

                res = await axios.post(
                    "https://my-sarad-back.liara.run/api/auth/login",
                    { phone: obj.phone }
                );

            } else {
                // login = false → API register

                res = await axios.post(
                    "https://my-sarad-back.liara.run/api/auth/register",
                    {
                        firstName: obj.firstName,
                        lastName: obj.lastName,
                        phone: obj.phone
                    }
                );
            }

            // اگر درخواست موفق بود → OTP جدید زده شد
            const newOtpData = {
                ...obj,
                otpSendTime: new Date(),
                otpSended: true
            };

            localStorage.setItem("otp", JSON.stringify(newOtpData));

            showToast(toast.success, "کد دوباره ارسال شد");

        } catch (err) {
            const msg = err?.response?.data?.message || "مشکلی در ارسال مجدد کد رخ داده است";
            showToast(toast.error, msg);
        }
    };

    return (

        <div className="bg-white w-full max-w-md rounded-2xl shadow-lg p-8">

            <h2 className="text-xl font-semibold text-slate-800 text-center">
                کد اعتبارسنجی
            </h2>

            <p className="text-sm text-slate-500 text-center mt-2">
                لطفا کد ارسال‌شده را وارد کنید
            </p>

            {/* OTP single input */}
            <input
                type="text"
                value={code}
                maxLength={4}
                onChange={(e) => handleChange(e.target.value)}
                placeholder="کد ۴ رقمی"
                className="
                    w-full
                    mt-8
                    h-14
                    rounded-xl
                    border
                    border-slate-300
                    bg-slate-100
                    text-center
                    text-lg
                    tracking-[0.3em]
                    outline-none
                    transition
                    focus:border-third
                "
            />

            {/* submit */}
            <button
                onClick={handleVerify}
                className="
                    w-full
                    bg-primary
                    text-white
                    mt-8
                    py-4
                    rounded-xl
                    text-base
                    font-bold
                    transition
                    hover:opacity-90
                    active:scale-[0.98]
                "
            >
                تایید
            </button>

            {/* resend code */}
            <div className="text-center mt-5 text-sm text-slate-600">
                کد دریافت نکردید؟
                <button
                    onClick={handleResend}
                    className="text-primary font-medium mr-1"
                >
                    ارسال مجدد
                </button>
            </div>

        </div>

    );
};

export default AuthOtp;